// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lookbook[data-v-086004a6]{margin-bottom:32px}@media screen and (max-width:750px){.lookbook[data-v-086004a6]{background:#fff}}.lookbook__title[data-v-086004a6]{align-items:center;display:flex;height:36px;justify-content:center;text-align:center}.lookbook>.row[data-v-086004a6]{flex-wrap:nowrap;gap:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
